module.exports = __webpack_public_path__ + "static/img/buy-vip-bg.15e50e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/buy-vip-bg.jpg
// module id = t6xh
// module chunks = 1